/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentScheduleSubscriberDto } from './PaymentScheduleSubscriberDto';
import {
    PaymentScheduleSubscriberDtoFromJSON,
    PaymentScheduleSubscriberDtoFromJSONTyped,
    PaymentScheduleSubscriberDtoToJSON,
    PaymentScheduleSubscriberDtoToJSONTyped,
} from './PaymentScheduleSubscriberDto';
import type { PaymentScheduleBrokerDto } from './PaymentScheduleBrokerDto';
import {
    PaymentScheduleBrokerDtoFromJSON,
    PaymentScheduleBrokerDtoFromJSONTyped,
    PaymentScheduleBrokerDtoToJSON,
    PaymentScheduleBrokerDtoToJSONTyped,
} from './PaymentScheduleBrokerDto';

/**
 * Detailed information about a payment schedule (échéance de paiement)
 * @export
 * @interface EcheancePaiementDetailDto
 */
export interface EcheancePaiementDetailDto {
    /**
     * Whether the payment is external
     * @type {boolean}
     * @memberof EcheancePaiementDetailDto
     */
    isExternal: boolean;
    /**
     * Pure premium amount
     * @type {number}
     * @memberof EcheancePaiementDetailDto
     */
    purePremium: number;
    /**
     * Commission amount
     * @type {number}
     * @memberof EcheancePaiementDetailDto
     */
    commissions: number;
    /**
     * Tax amount
     * @type {number}
     * @memberof EcheancePaiementDetailDto
     */
    tax: number;
    /**
     * Fees amount
     * @type {number}
     * @memberof EcheancePaiementDetailDto
     */
    fees: number;
    /**
     * Date when the withdrawal was made
     * @type {Date}
     * @memberof EcheancePaiementDetailDto
     */
    withdrawalDate?: Date | null;
    /**
     * Direct debit key
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    directDebitKey?: string | null;
    /**
     * SEPA reference
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    sepaReference?: string | null;
    /**
     * Unique mandate reference (Référence Unique de Mandat)
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    rum?: string | null;
    /**
     * Date when the direct debit was created
     * @type {Date}
     * @memberof EcheancePaiementDetailDto
     */
    directDebitCreationDate?: Date | null;
    /**
     * Debtor IBAN
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    debtorIban?: string | null;
    /**
     * Creditor IBAN
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    creditorIban?: string | null;
    /**
     * Date when the SEPA mandate was signed
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    mandateSignatureDate?: string | null;
    /**
     * Number of payment retry attempts
     * @type {number}
     * @memberof EcheancePaiementDetailDto
     */
    retryCount: number;
    /**
     * Date of the last retry attempt
     * @type {Date}
     * @memberof EcheancePaiementDetailDto
     */
    lastRetryDate?: Date | null;
    /**
     * Last error message from payment processing
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    lastErrorMessage?: string | null;
    /**
     * Last return code from payment processing
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    lastReturnCode?: string | null;
    /**
     * Date when the payment was marked as unpaid
     * @type {Date}
     * @memberof EcheancePaiementDetailDto
     */
    unpaidDate?: Date | null;
    /**
     * Reason code for the unpaid status
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    unpaidReasonCode?: string | null;
    /**
     * Label describing the rejection reason
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    rejectionLabel?: string | null;
    /**
     * Whether the payment has an unpaid status
     * @type {boolean}
     * @memberof EcheancePaiementDetailDto
     */
    hasUnpaid: boolean;
    /**
     * Date when the unpaid was regularized
     * @type {Date}
     * @memberof EcheancePaiementDetailDto
     */
    regularizationDate?: Date | null;
    /**
     * Unique identifier of the contract
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    contractId: string;
    /**
     * Contract number
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    contractNumber: string;
    /**
     * Current status of the contract
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    contractStatus: string;
    /**
     * Effective date of the contract
     * @type {Date}
     * @memberof EcheancePaiementDetailDto
     */
    contractEffectDate: Date;
    /**
     * Qui la plateforme prélève — SOUSCRIPTEUR ou COURTIER (courtier encaisseur)
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    contractPayer?: EcheancePaiementDetailDtoContractPayerEnum | null;
    /**
     * Name of the associated product
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    productName: string;
    /**
     * Unique identifier of the receipt
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    receiptId?: string | null;
    /**
     * Receipt number
     * @type {string}
     * @memberof EcheancePaiementDetailDto
     */
    receiptNumber?: string | null;
    /**
     * Start date of the receipt period
     * @type {Date}
     * @memberof EcheancePaiementDetailDto
     */
    receiptStartDate?: Date | null;
    /**
     * End date of the receipt period
     * @type {Date}
     * @memberof EcheancePaiementDetailDto
     */
    receiptEndDate?: Date | null;
    /**
     * Total amount of the receipt
     * @type {number}
     * @memberof EcheancePaiementDetailDto
     */
    receiptTotalAmount?: number | null;
    /**
     * 
     * @type {PaymentScheduleSubscriberDto}
     * @memberof EcheancePaiementDetailDto
     */
    subscriber: PaymentScheduleSubscriberDto;
    /**
     * 
     * @type {PaymentScheduleBrokerDto}
     * @memberof EcheancePaiementDetailDto
     */
    broker: PaymentScheduleBrokerDto;
}


/**
 * @export
 */
export const EcheancePaiementDetailDtoContractPayerEnum = {
    Souscripteur: 'SOUSCRIPTEUR',
    Courtier: 'COURTIER'
} as const;
export type EcheancePaiementDetailDtoContractPayerEnum = typeof EcheancePaiementDetailDtoContractPayerEnum[keyof typeof EcheancePaiementDetailDtoContractPayerEnum];


/**
 * Check if a given object implements the EcheancePaiementDetailDto interface.
 */
export function instanceOfEcheancePaiementDetailDto(value: object): value is EcheancePaiementDetailDto {
    if (!('isExternal' in value) || value['isExternal'] === undefined) return false;
    if (!('purePremium' in value) || value['purePremium'] === undefined) return false;
    if (!('commissions' in value) || value['commissions'] === undefined) return false;
    if (!('tax' in value) || value['tax'] === undefined) return false;
    if (!('fees' in value) || value['fees'] === undefined) return false;
    if (!('retryCount' in value) || value['retryCount'] === undefined) return false;
    if (!('hasUnpaid' in value) || value['hasUnpaid'] === undefined) return false;
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    if (!('contractNumber' in value) || value['contractNumber'] === undefined) return false;
    if (!('contractStatus' in value) || value['contractStatus'] === undefined) return false;
    if (!('contractEffectDate' in value) || value['contractEffectDate'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('subscriber' in value) || value['subscriber'] === undefined) return false;
    if (!('broker' in value) || value['broker'] === undefined) return false;
    return true;
}

export function EcheancePaiementDetailDtoFromJSON(json: any): EcheancePaiementDetailDto {
    return EcheancePaiementDetailDtoFromJSONTyped(json, false);
}

export function EcheancePaiementDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcheancePaiementDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isExternal': json['isExternal'],
        'purePremium': json['purePremium'],
        'commissions': json['commissions'],
        'tax': json['tax'],
        'fees': json['fees'],
        'withdrawalDate': json['withdrawalDate'] == null ? undefined : (new Date(json['withdrawalDate'])),
        'directDebitKey': json['directDebitKey'] == null ? undefined : json['directDebitKey'],
        'sepaReference': json['sepaReference'] == null ? undefined : json['sepaReference'],
        'rum': json['rum'] == null ? undefined : json['rum'],
        'directDebitCreationDate': json['directDebitCreationDate'] == null ? undefined : (new Date(json['directDebitCreationDate'])),
        'debtorIban': json['debtorIban'] == null ? undefined : json['debtorIban'],
        'creditorIban': json['creditorIban'] == null ? undefined : json['creditorIban'],
        'mandateSignatureDate': json['mandateSignatureDate'] == null ? undefined : json['mandateSignatureDate'],
        'retryCount': json['retryCount'],
        'lastRetryDate': json['lastRetryDate'] == null ? undefined : (new Date(json['lastRetryDate'])),
        'lastErrorMessage': json['lastErrorMessage'] == null ? undefined : json['lastErrorMessage'],
        'lastReturnCode': json['lastReturnCode'] == null ? undefined : json['lastReturnCode'],
        'unpaidDate': json['unpaidDate'] == null ? undefined : (new Date(json['unpaidDate'])),
        'unpaidReasonCode': json['unpaidReasonCode'] == null ? undefined : json['unpaidReasonCode'],
        'rejectionLabel': json['rejectionLabel'] == null ? undefined : json['rejectionLabel'],
        'hasUnpaid': json['hasUnpaid'],
        'regularizationDate': json['regularizationDate'] == null ? undefined : (new Date(json['regularizationDate'])),
        'contractId': json['contractId'],
        'contractNumber': json['contractNumber'],
        'contractStatus': json['contractStatus'],
        'contractEffectDate': (new Date(json['contractEffectDate'])),
        'contractPayer': json['contractPayer'] == null ? undefined : json['contractPayer'],
        'productName': json['productName'],
        'receiptId': json['receiptId'] == null ? undefined : json['receiptId'],
        'receiptNumber': json['receiptNumber'] == null ? undefined : json['receiptNumber'],
        'receiptStartDate': json['receiptStartDate'] == null ? undefined : (new Date(json['receiptStartDate'])),
        'receiptEndDate': json['receiptEndDate'] == null ? undefined : (new Date(json['receiptEndDate'])),
        'receiptTotalAmount': json['receiptTotalAmount'] == null ? undefined : json['receiptTotalAmount'],
        'subscriber': PaymentScheduleSubscriberDtoFromJSON(json['subscriber']),
        'broker': PaymentScheduleBrokerDtoFromJSON(json['broker']),
    };
}

export function EcheancePaiementDetailDtoToJSON(json: any): EcheancePaiementDetailDto {
    return EcheancePaiementDetailDtoToJSONTyped(json, false);
}

export function EcheancePaiementDetailDtoToJSONTyped(value?: EcheancePaiementDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isExternal': value['isExternal'],
        'purePremium': value['purePremium'],
        'commissions': value['commissions'],
        'tax': value['tax'],
        'fees': value['fees'],
        'withdrawalDate': value['withdrawalDate'] == null ? undefined : ((value['withdrawalDate'] as any).toISOString()),
        'directDebitKey': value['directDebitKey'],
        'sepaReference': value['sepaReference'],
        'rum': value['rum'],
        'directDebitCreationDate': value['directDebitCreationDate'] == null ? undefined : ((value['directDebitCreationDate'] as any).toISOString()),
        'debtorIban': value['debtorIban'],
        'creditorIban': value['creditorIban'],
        'mandateSignatureDate': value['mandateSignatureDate'],
        'retryCount': value['retryCount'],
        'lastRetryDate': value['lastRetryDate'] == null ? undefined : ((value['lastRetryDate'] as any).toISOString()),
        'lastErrorMessage': value['lastErrorMessage'],
        'lastReturnCode': value['lastReturnCode'],
        'unpaidDate': value['unpaidDate'] == null ? undefined : ((value['unpaidDate'] as any).toISOString()),
        'unpaidReasonCode': value['unpaidReasonCode'],
        'rejectionLabel': value['rejectionLabel'],
        'hasUnpaid': value['hasUnpaid'],
        'regularizationDate': value['regularizationDate'] == null ? undefined : ((value['regularizationDate'] as any).toISOString()),
        'contractId': value['contractId'],
        'contractNumber': value['contractNumber'],
        'contractStatus': value['contractStatus'],
        'contractEffectDate': ((value['contractEffectDate']).toISOString()),
        'contractPayer': value['contractPayer'],
        'productName': value['productName'],
        'receiptId': value['receiptId'],
        'receiptNumber': value['receiptNumber'],
        'receiptStartDate': value['receiptStartDate'] == null ? undefined : ((value['receiptStartDate'] as any).toISOString()),
        'receiptEndDate': value['receiptEndDate'] == null ? undefined : ((value['receiptEndDate'] as any).toISOString()),
        'receiptTotalAmount': value['receiptTotalAmount'],
        'subscriber': PaymentScheduleSubscriberDtoToJSON(value['subscriber']),
        'broker': PaymentScheduleBrokerDtoToJSON(value['broker']),
    };
}

